const STORAGE_KEY = 'SHOW_INVITATION_MODAL';

export const setAutoShowInvitationModal = () => {
  sessionStorage.setItem(STORAGE_KEY, 'true');
};

export const removeAutoShowInvitationModal = () => {
  sessionStorage.removeItem(STORAGE_KEY);
};

export const getAutoShowInvitationModal = () => {
  return sessionStorage.getItem(STORAGE_KEY);
};
